const styles = theme => ({

    mainBox: {
        height: '90% !important',
        width: '100% !important',
        top: 0,
        left: 0,
        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
    },

    maincontentBox: {
        width: "100% !important",
        display: "flex !important",
        justifyContent: "end !important"
    },

    heading: {
        fontFamily: 'cardiuma-M !important',
        fontSize: '25px !important',
        color: '#282828 !important',
        fontWeight: 'bold !important'
    },

    historyButton: {
        backgroundColor: "#F74542 !important",
        padding: "10px 15px 10px 15px !important",
        fontStyle: "normal !important",
        fontSize: "16px !important",
        textTransform: "initial !important",
        fontFamily: "cardiuma-M !important",
        color: '#ffffff !important',
        margin: "20px 30px 0px 0px !important"
    },

    historyModalHead: {
        display: "flex !important",
        justifyContent: "space-between !important",
        alignItems: "center !important",
        marginBottom: '14px !important',
    },

    historyModalHeadText: {
        flex: 1,
        textAlign: "center !important",
        ml: "-32px !important",
        fontFamily: "cardiuma-M !important",
    },

    historyModalContent: {
        border: "1px solid #ddd",
        borderRadius: '16px !important',
        padding: '16px !important',
        marginBottom: '16px !important',
        backgroundColor: "#f9f9f9 !important",
        marginRight: '2px !important'
    },

    centerBox: {
        width: "100% !important",
        height: "70% !important",
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
    },

    appRejPenBox: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
    },

    appRejPenText: {
        fontFamily: "cardiuma-regular !important",
        fontSize: "20px !important",
        color: "#6b6767 !important",
    },

    select: {
        marginTop: '10px !important',
        color: "#000000 !important",
        width: "100% !important",
        fontFamily: "cardiuma-regular !important",
    },

    inputColor: {
        color: "#000000 !important",
        fontFamily: "cardiuma-regular ! important",
        fontSize: "16px ! important",
        fontWeight: 500,
        paddingBottom: '10px !important'
    },

    uploadBox: {
        width: "100% !important",
        height: '60px !important',
        border: "2px dashed #aaa !important",
        borderRadius: '16px !important',
        display: "flex !important",
        alignItems: "center !important",
        justifyContent: "center !important",
        cursor: "pointer !important",
    },

    uploadButton: {
        backgroundColor: "#F74542 !important",
        padding: "10px 5px !important",
        fontStyle: "normal !important",
        fontSize: "16px !important",
        textTransform: "initial !important",
        fontFamily: "cardiuma-M !important",
        color: '#ffffff !important'
    },

    disableButton: {
        backgroundColor: "#d1d1d1ff !important",
        padding: "10px 5px !important",
        fontStyle: "normal !important",
        fontSize: "16px !important",
        textTransform: "initial !important",
        fontFamily: "cardiuma-M !important",
        color: 'rgba(219, 219, 219, 1)ff !important'
    },

    text: {
        fontFamily: "cardiuma-M !important",
    },

    historyModal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px !important',
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: '24px !important',
        padding: '32px !important',
    },

    errorBox: {
        textAlign: "center !important",
        paddingTop: "10px !important",
        color: "red !important",
    }
})

export default styles
